import { createFrontendModule } from '@backstage/frontend-plugin-api';
import { appFormFields } from './formFields';
import { teamManagementFormFields } from './teamManagementFormFields';

// PAT-1025: `/create` is served by `@backstage/plugin-scaffolder/alpha`. Its
// template wizard takes custom fields from `api:scaffolder/form-fields`, which
// collects every `FormFieldBlueprint` of the `scaffolder` plugin, so this
// module (same plugin id) registers ours there instead of the legacy
// `<ScaffolderFieldExtensions>` children of the `/create` route. Their ids are
// `scaffolder-form-field:scaffolder/<name>`; don't reuse the name of an
// upstream field (`entity-picker`, `owner-picker`, `repo-url-picker`, ...) or
// it replaces that one. Add new custom fields here.
export const scaffolderModule = createFrontendModule({
  pluginId: 'scaffolder',
  extensions: [...appFormFields, ...teamManagementFormFields],
});
